import { Duration } from 'luxon';

export class PlanWithJobStateRequest {
  id?: string;
  planContainerId?: string;
  organizationUnitId?: string;
  connectionId?: string;
  planData?: PlanDataStateRequest;
  jobRequestDtos?: JobStateRequest[];
}

export class PlanDataStateRequest {
  name?: string;
  description?: string;
}

export class JobStateRequest {
  vehicleType?: string;
  quantity?: number;
  startTerminal?: StartTerminalStateRequest;
  endTerminal?: EndTerminalStateRequest;
  startTerminalName?: string;
  endTerminalName?: string;
  startTerminalAddress?: string;
  endTerminalAddress?: string;
  jobTemplate? : string;
  startFrom?: Duration;
  endAt?: Duration;
  capacityType1?: number;
  capacityType2?: number;
  capacityType3?: number;
  vehicleProfile?: string;
  speedFactor?:number;
  maxLocations?:number;
}

export class StartTerminalStateRequest {
    identifier?: string;
    latitude?: number;
    longitude?: number;
}

export class EndTerminalStateRequest {
    identifier?: string;
    latitude?: number;
    longitude?: number;
}

